<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: 'SimSun';
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue